module.exports = __webpack_public_path__ + "img/testimonial-6-61x61_1testimonial-6-61x61.deb45948.png";